import React, { useState, useEffect, useRef } from 'react';
import Logo from '../Elem5-Logo/Elem5Logo.jsx';
import './Sec3Sections.css';
import { useLocation } from 'react-router-dom';
import Data from '../../Data/Data.jsx'; 
import Elem1Submit from '../Elem1-Submit/Elem1Submit.jsx';
import Elem4Next from '../Elem4-Next/Elem4Next.jsx';
import axios from 'axios';
import ApexChart from './ApexChart.jsx';
import BubbleChart from './BubbleChart.jsx';
import Elem3SaveDraft from '../Elem3-SaveDraft/Elem3SaveDraft.jsx';
import Elem6SaveDraftFloating from '../Elem6-SaveDraft-Floating/Elem6SaveDraftFloating.jsx';
import { Tooltip } from 'react-tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';

function areAllQuestionsAnswered(duperesponses, data) {
  for (const pillarData of data) {
    for (const question of pillarData.questions) {
      if (!duperesponses[pillarData.id]?.[question.questionNumber]) {
        return false; 
      }
    }
  }
  return true;
}

function areAllQuestionsAnsweredPerSection(duperesponses, data, pillarIndex) {
  const pillarData = data[pillarIndex];
  for (const question of pillarData.questions) {
    if (!duperesponses[pillarData.id]?.[question.questionNumber]) {
      return false; 
    }
  }
  return true;
}


var email_id = '';
var type = 0;
var basic_detailsId  = 0;
var insertStatus = 0;
var established_yr = '';
var organization_company = '';


function extractSurveyData(responseData) {
  if(responseData.basic_details.length>0){
    for(const bd of responseData.basic_details){
      email_id = bd.email_id;
      type = bd.type;
      established_yr = bd.established_year
      organization_company = bd.organization
      if(insertStatus==0){
        basic_detailsId = bd.id;
      }
    }
  }

  const pillarNameIDMappings = {
    "innovation_collaboration": 6,
    "operating_model": 2,
    "people_culture": 4,
    "portfolio_ownership": 3,
    "process_enablement": 5,
    "strategic_intent": 1
  };

  var pillardataResponse = {};

  if(type==1){
     pillardataResponse = responseData.erd;
  }else{
     pillardataResponse = responseData.it;
  }

  var replacedpillarResponse = [];
  for (const key in pillardataResponse) {
    if (pillarNameIDMappings.hasOwnProperty(key)) {
      if(pillardataResponse[key]!="pillar_scores" && pillardataResponse[key]!="survey_scores")
      {
        replacedpillarResponse[pillarNameIDMappings[key]] = pillardataResponse[key]
      }
    }
  }

  const finalDataResponse = {};

  for (const pillarId in replacedpillarResponse) {
    finalDataResponse[pillarId] = {};
    for (const question of replacedpillarResponse[pillarId]) {
      const answer = question.answer;
      finalDataResponse[pillarId][question.question_id] = answer;
    }
  }
  return finalDataResponse;
}

function Sec3Sections() {
  const location = useLocation();
  const [industryValue, setIndustryValue] = useState('');
  const [activePillarIndex, setActivePillarIndex] = useState(0);
  const [totalScore, setTotalScore] = useState(0);
  const [establishedYear, setEstablishedYear] = useState(0);
  const [pillarScores, setPillarScores] = useState();
  const [pillarScoresnew, setnewPillarScores] = useState();
  const [submitted, setSubmitted] = useState(false); 
  const [organization, setOrganization] = useState('');
  const [answeredPillars,setAnsweredPillars] = useState([]);
  const [responses, setResponses] = useState(() => {
    const savedData = localStorage.getItem("selectedData");
    return savedData ? JSON.parse(savedData) : {};
  });
  const [duperesponses, setdupeResponses] = useState(() => {
    const savedData = localStorage.getItem("selectedData");
    return savedData ? JSON.parse(savedData) : {};
  });
  const [prepopulatedResponses, setPrepopulatedResponses] = useState(() => {
    const savedData = localStorage.getItem("selectedData");
    return savedData ? JSON.parse(savedData) : {};
  });
  const [selectedData, setSelectedData] = useState({
    dataId: '',
    name: '',
    pillars: [{ 
      id: '', 
      pillar: '', 
      percentage: '', 
      questions: [{ 
        questionNumber: '', 
        weight: '', 
        question: '', 
        options: [{ option: '', optionNumber: '', marks: '' }] // Placeholder for options
      }] 
    }] 
  });
  const [DraftedData, setDraftedData] = useState({
    dataId: '',
    name: '',
    pillars: [{ 
      id: '', 
      pillar: '', 
      percentage: '', 
      questions: [{ 
        questionNumber: '', 
        weight: '', 
        question: '', 
        options: [{ option: '', optionNumber: '', marks: '' }] 
      }] 
    }] 
  });
 
  //Block which gets the state data passed from the previous screen
  useEffect(() => {
    if(location.state){
      if(location.state.basicDetailFormData){
        email_id = location.state.basicDetailFormData.email_id;
        established_yr = location.state.basicDetailFormData.established_year;
        setEstablishedYear(established_yr);
        organization_company = location.state.basicDetailFormData.organization
        setOrganization(organization_company); //added recent requirment
      }
      if(location.state.industryValue){
        type = location.state.industryValue;
        setIndustryValue(location.state.industryValue);
      }

      if(location.state.basic_details_id){
        basic_detailsId = location.state.basic_details_id;
        console.log("Basic Details ID "+basic_detailsId);
      }

      if(location.state.insertStatus){
        insertStatus = location.state.insertStatus;
        console.log("Insert Status "+insertStatus);
      }
    }
  }, [location.state]);
  //Block which gets the state data passed from the previous screen

  useEffect(() => {
    if (pillarScores) {
      const total = Object.values(pillarScores).reduce((acc, score) => acc + score, 0);
      setTotalScore(total);
    }
  }, [pillarScores]);
  const totalScoreInteger = parseInt(totalScore);


  useEffect(() => {
    const fetchData = () => {
      axios.post("https://zinnov.com/global-capability-center-maturity-index/maturity-index-survey-api/fetch-survey-data/",{'email_id':email_id})
        .then(response => {
          const surveyData = response.data;
          const extractedData = extractSurveyData(surveyData);
          setResponses(extractedData);
          setPrepopulatedResponses(extractedData);
          setdupeResponses(extractedData) //changes
          setEstablishedYear(established_yr);
          setOrganization(organization_company);
        })
        .catch(error => {
          console.error("Error fetching survey data:", error);
        });
    };
    fetchData();
  }, []); 

  useEffect(() => {
    const selected = Data.find(item => item.dataId === industryValue);
    setSelectedData(selected || {
      dataId: '',
      name: '',
      pillars: [{ 
        id: '', 
        pillar: '', 
        percentage: '', 
        questions: [{ 
          questionNumber: '', 
          weight: '', 
          question: '', 
          options: [{ option: '', optionNumber: '', marks: '' }] // Placeholder for options
        }] 
      }] 
    });
  }, [industryValue]);

  useEffect(() => {
    const drafted = Data.find(item => item.dataId === industryValue);
    setDraftedData(drafted || {
      dataId: '',
      name: '',
      pillars: [{ 
        id: '', 
        pillar: '', 
        percentage: '', 
        questions: [{ 
          questionNumber: '', 
          weight: '', 
          question: '', 
          options: [{ option: '', optionNumber: '', marks: '' }] // Placeholder for options
        }]
      }] 
    });
  }, [industryValue]);

  useEffect(() => {
    const calculatePillarScores = () => {
      const updatedPillarScores = {};
      const updatednewPillarScores = {};
      selectedData.pillars.forEach(pillarData => {
        let totalScore = 0;
        pillarData.questions.forEach(question => {
          const selectedOption = duperesponses[pillarData.id]?.[question.questionNumber];
          // responses ^ to duperesponses
          if (selectedOption) {
            const option = question.options.find(opt => opt.option === selectedOption);
            if(option!==undefined){
              totalScore += option.marks * ((question.weight)/100);
            }
           
          }
        });
        totalScore *= (pillarData.percentage/100);
        updatedPillarScores[pillarData.pillar] = totalScore;
        
        const rescalePillarScores = () => {
          const scalingFactor = (5 - 1);
          return Math.round((totalScore) * scalingFactor + 1);
        };

        updatednewPillarScores[pillarData.pillar] = totalScore;


      });
      setPillarScores(updatedPillarScores);
      setnewPillarScores(updatednewPillarScores);
    };
    calculatePillarScores();
  }, [duperesponses, selectedData.pillars]); 

    useEffect(() => {
      const updateAnsweredPillars = selectedData.pillars.map((pillar,index) => {
        return areAllQuestionsAnsweredPerSection(duperesponses, selectedData.pillars, index);
      });
      console.log("Answered Pillars");
      console.log(updateAnsweredPillars);
      setAnsweredPillars(updateAnsweredPillars);
  }, [duperesponses, selectedData.pillars]);

  const handleNext = () => {
    if (activePillarIndex < selectedData.pillars.length - 1) {
      setActivePillarIndex(activePillarIndex + 1);
    }
  };

  const handleSubmit = () => {
      // const dataSubmitted = sessionStorage.getItem('dataSubmitted');
      // if (dataSubmitted === 'true') {
      //   // If data has already been submitted, return early or show a message
      //   console.log("Data has already been submitted.");
      //   return;
      // }
    
    
      // ===================== INSERT QUESTIONS ANSWER =========================
      const QuestionAnswerPromises = [];
      const pillarNameIDMappings = {
        "innovation_collaboration": 6,
        "operating_model": 2,
        "people_culture": 4,
        "portfolio_ownership": 3,
        "process_enablement": 5,
        "strategic_intent": 1
      };
      const allPillarData = {};
      for (const pillarName in pillarNameIDMappings) {
        if (pillarNameIDMappings.hasOwnProperty(pillarName)) {
          const pillarId = pillarNameIDMappings[pillarName];
          const pillarQuestions = selectedData.pillars.find(pillar => pillar.id === pillarId)?.questions || [];
          const pillarData = pillarQuestions.map(question => ({
            basic_details_id: basic_detailsId,
            type: industryValue,
            question_id: question.questionNumber,
            question: question.question,
            answer: duperesponses[pillarId]?.[question.questionNumber] || '',
                      // responses ^ to duperesponses
            answer_id: "1",
            createdtimestamp: new Date().toISOString().replace(/T/, ' ').replace(/\..+/, '')
          }));
          allPillarData[pillarName] = pillarData;
        }
      }

      QuestionAnswerPromises.push(
        axios.post("https://zinnov.com/global-capability-center-maturity-index/maturity-index-survey-api/insert-survey-question-answers/", allPillarData)
          .then(res => {
            console.log("All pillar data has been sent successfully.");
            console.log(allPillarData);
          })
          .catch(error => {
            console.error("Error sending data:", error);
          })
      );

      console.log(QuestionAnswerPromises)
      Promise.all(QuestionAnswerPromises)
        .then(responses => {
          // console.log("All data sent successfully:", responses);
          setSubmitted(true);
        })
        .catch(error => {
          console.error("Error sending data:", error);
        });
    

      // ===================== PILLAR SCORE =========================
      const pillarScorePromises = [];
      for (let i = 0; i < selectedData.pillars.length; i++) {
        const pillar = selectedData.pillars[i];
        const pillarScoresData = {
          basic_details_id: basic_detailsId,
          type: industryValue,
          pillar: pillar.pillar,
          score: pillarScores[pillar.pillar],
          createdtimestamp: new Date().toISOString().replace(/T/, ' ').replace(/\..+/, '') 
        };
        pillarScorePromises.push(
          axios.post("https://zinnov.com/global-capability-center-maturity-index/maturity-index-survey-api/insert-pillar-scores/", pillarScoresData)
            .then(res => {
              // console.log(`Pillar score data for ${pillar.pillar} submitted successfully.`);
            })
            .catch(err => {
              console.error(`Error posting pillar scores for ${pillar.pillar}:`, err);
            })
        );
      }
      Promise.all(pillarScorePromises)
        .then(() => {
          console.log("All pillar scores submitted successfully.");
          setSubmitted(true);
      });


      // ===================== TOTAL SCORE =========================
      const totalScore = Object.values(pillarScores).reduce((acc, score) => acc + score, 0);
      const surveyScoresData = {
        basic_details_id: basic_detailsId,
        type: industryValue,
        score: totalScore,
        createdtimestamp: new Date().toISOString().replace(/T/, ' ').replace(/\..+/, '') 
      };
      axios.post("https://zinnov.com/global-capability-center-maturity-index/maturity-index-survey-api/insert-survey-scores/", surveyScoresData)
        .then(res => {
          setSubmitted(true);
        })
        .catch(err => {
          console.error('Error posting survey scores:', err);
        });

        // ============= Update Submit Button Status =============
        // axios.post("https://zinnov.com/global-capability-center-maturity-index/maturity-index-survey-api/update_submit_btn_status/", {'email_id':email_id})
        // .then(res => {
        //   console.log("Verify Email Existence Result");
        //   console.log(res);
        //   if ((res.data.status === 1) || (res.data.status === 0)){
        //       if(res.data.type === 0) {
        //           setShowRegistrationForm(true);
        //       } 
        //       else {

        //         }
        //       }
        //   })
        //   .catch(err => {
        //       console.error('Error recieving status:', err);
        //   });

  };

  const handleSaveDraft = () => {
    console.log("Handle Save Draft Called");
    console.log(responses);
    console.log(DraftedData.pillars);
    console.log(activePillarIndex);
    

    console.log(areAllQuestionsAnsweredPerSection(responses, DraftedData.pillars, activePillarIndex));
    const QuestionAnswerPromises = [];
    const pillarNameIDMappings = {
      "innovation_collaboration": 6,
      "operating_model": 2,
      "people_culture": 4,
      "portfolio_ownership": 3,
      "process_enablement": 5,
      "strategic_intent": 1
    };

    // console.log("selectedData.pillars")
    // console.log(selectedData.pillars)

    // console.log("DraftedData.pillars")
    // console.log(DraftedData.pillars)

    var allPillarData = {};
    for (const pillarName in pillarNameIDMappings) {
      if (pillarNameIDMappings.hasOwnProperty(pillarName)) {
        const pillarId = pillarNameIDMappings[pillarName];
        const pillarQuestions = DraftedData.pillars.find(pillar => pillar.id === pillarId)?.questions || [];


        const pillarData = pillarQuestions.reduce((acc, question) => {
          const answer = responses[pillarId]?.[question.questionNumber];

          if (answer !== undefined && answer !== null && answer !== "") {
            acc.push({
              basic_details_id: basic_detailsId,
              type: industryValue,
              question_id: question.questionNumber,
              question: question.question,
              answer: answer,
              answer_id: "1",
              createdtimestamp: new Date().toISOString().replace(/T/, ' ').replace(/\..+/, '')
            });
          }
          
          return acc;
        }, []);

        if (pillarData.length > 0) {
          allPillarData[pillarName] = pillarData;
        } 
      }
    }

    // console.log("allPillarData")
    // console.log(allPillarData)

    console.log("answeredPillars")
    console.log(answeredPillars)
    
    console.log("setAnsweredPillars")
    console.log(setAnsweredPillars)
    

    QuestionAnswerPromises.push(
      axios.post("https://zinnov.com/global-capability-center-maturity-index/maturity-index-survey-api/insert-survey-question-answers/", allPillarData)
        .then(res => {
          console.log("All pillar data has been sent successfully.");
          console.log("allpillardata inside api")
          console.log(allPillarData);
          console.log("Saved");

          console.log("DraftedData")
          console.log(DraftedData);
        })
        .catch(error => {
          console.error("Error sending data:", error);
        })
    );

    Promise.all(QuestionAnswerPromises)
      .then(responses => {
        console.log("Data sent successfully:", responses);
        localStorage.setItem("DraftedData", JSON.stringify({}));
        setResponses({});
      })
      .catch(error => {
        console.error("Error sending data:", error);
      });
  }

  const handleResponseChange = (pillarId, questionNumber, selectedOption) => {
    setResponses(prevResponses => ({
      ...prevResponses,
      [pillarId]: {
        ...prevResponses[pillarId],
        [questionNumber]: selectedOption
      }
    }));
    
    setdupeResponses(prevResponses => ({
      ...prevResponses,
      [pillarId]: {
        ...prevResponses[pillarId],
        [questionNumber]: selectedOption
      }
    }));
    
    setPrepopulatedResponses(prevResponses => ({
      ...prevResponses,
      [pillarId]: {
        ...prevResponses[pillarId],
        [questionNumber]: selectedOption
      }
    }));

  
    const storedData = JSON.parse(localStorage.getItem("selectedData")) || {};
    const updatedStoredData = {
      ...storedData,
      [pillarId]: {
        ...storedData[pillarId],
        [questionNumber]: selectedOption
      }
    };
    localStorage.setItem("selectedData", JSON.stringify(updatedStoredData));

    const storedDraftedData = JSON.parse(localStorage.getItem("DraftedData")) || {};
    const updatedstoredDraftedData = {
      ...storedDraftedData,
      [pillarId]: {
        ...storedDraftedData[pillarId],
        [questionNumber]: selectedOption
      }
    };
    localStorage.setItem("DraftedData", JSON.stringify(updatedstoredDraftedData));
 
  };


  
  const allQuestionsAnswered = areAllQuestionsAnswered(duperesponses, selectedData.pillars);

  return (
    <div className='Sec3Sections'>
          {submitted ? (
            <div>
            <div className='PillarContainerScores'>
              <div className='Sec3Sections-container Sectext'>
                <Logo />
                <h1>Maturity Index</h1>
                <h2>Online Survey</h2>
                {pillarScores && <PillarScores pillarScores={pillarScores} />}
              </div>
              <div className="apex">
                {/* pillarScores={pillarScores} */}
                <ApexChart totalScore={totalScoreInteger} organization={organization} />
              </div>
            </div>
            {/* sending props */}
        </div>
          ) : (
            <>
          <div className='Sec3Sections-container Sectext'>
            <Logo />
            <h1>Maturity Index</h1>
            <h2>Online Survey</h2>
            <p>The survey comprises <b>six sections</b>, each of which must be completed to finalize your <br /> score. You may navigate between sections seamlessly using the navigation bars <br /> provided below at any point during the survey.</p>
          </div>
          <div className='PillarContainer'>
            {selectedData.pillars.map((item, index) => (
              <button
                className="pillar-button"
                key={item.pillar}
                style={{
                  backgroundColor: answeredPillars[index] ? 'green' :
                    (activePillarIndex === index ? '#e54242' : '#bcb6b6')
                }}
                onClick={() => {setActivePillarIndex(index); handleSaveDraft();}}
              >
                {item.pillar}
              </button>
            ))}
          </div>
          <Elem6Question
            currentPillar={selectedData.pillars[activePillarIndex].pillar}
            responses={responses}
            prepopulatedResponses = {prepopulatedResponses}
            handleResponseChange={handleResponseChange}
            selectedData={selectedData}
          />

          {allQuestionsAnswered ? (
            <div className='After-Submit'>
                <div className='SaveDraft-Button'>
                  <Elem3SaveDraft onClick={handleSaveDraft}/>
                </div>
                <div className='Submit-Button'>
                  <Elem1Submit onClick={handleSubmit} />
                </div>
            </div>
          ) : (
            <div>
              <div className='Non-Submit'>
                <div className='Next-Button'>
                  <Elem4Next onClick={()=>{handleNext(); handleSaveDraft();}} />
                </div>
                <div className='SaveDraft-Button'>
                  <Elem3SaveDraft onClick={handleSaveDraft}/>
                </div>
              </div>
              <div className='SaveDraft-FloatingButton'>
                  <Elem6SaveDraftFloating onClick={handleSaveDraft}/>
              </div>
            </div>
          )}    
        </>
      )}
      <Tooltip id="info-tooltip" />
    </div>
  );
}

function Elem6Question({ currentPillar, responses, prepopulatedResponses, handleResponseChange, selectedData }) {
  if (!selectedData || !selectedData.pillars || !Array.isArray(selectedData.pillars)) {
    return null;
  }
  return (
    <div className='Single-Question'>
      <div className='Single-Question-Container'>
        {selectedData.pillars.map((item) => (
          item.pillar === currentPillar &&
          <div className='Question-Group' key={item.pillar}>
            <div className='Question-Section'>
              {item.questions.map((question, qIndex) => (
                <div className="Question-num" key={qIndex}>
                  <h3 className='Qsn-title'>
                    QUESTION {question.questionNumber}
                  </h3>
                  <p className='Qsn-Qsn'>
                    {question.question} {question.info && (
                  <FontAwesomeIcon
                      icon={faCircleInfo}
                      className="info-icon"
                      data-tooltip-id={`info-tooltip`}
                      data-tooltip-html={question.info}
                    />
                )}
                  </p>
                  {question.options.map((option, oIndex) => (
                    <div className="Option" key={oIndex}>
                      <input
                        className="radio pad"
                        type='radio'
                        id={`option-${qIndex}-${oIndex}`}
                        name={`question-${qIndex}`}
                        value={option.option}
                        checked={prepopulatedResponses[item.id]?.[question.questionNumber] === option.option}
                        onChange={() => handleResponseChange(item.id, question.questionNumber, option.option)}
                      />
                      <label className="Qsn-options pad" htmlFor={`option-${qIndex}-${oIndex}`}>{option.option}</label>
                    </div>
                  ))}
                  <hr style={{ marginTop: '50px' }} />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}


function PillarScores({ pillarScores }) {
  const totalScore = Object.values(pillarScores).reduce((acc, score) => acc + score, 0);
  const totalScoreInteger = parseInt(totalScore);
  return (
    <div className="pillar-scores-container">
      <h2 style={{ color: "white"}}>Total Score: {totalScoreInteger}</h2>
      <ul style={{ color: "white",padding: "0px" }}>
        {Object.entries(pillarScores).map(([pillar, score]) => (
         <li key={pillar}>
            {pillar}: {(() => (Math.trunc(score * 10000) / 10000))()}
          </li>
        ))}
      </ul>
      <p className="report" style={{ lineHeight: "30px" }}>A detailed report will be mailed<br/>to you in a week’s time.</p>
    </div>
  );
}

export default Sec3Sections;